import React from "react";
import { CircularProgress } from "@mui/material";

export interface LoaderPageProps {
  loading: boolean;
}

export const LoaderPage: React.FC<LoaderPageProps> = () => {
  return (
    <div className="page flex-row-fc-fc">
      <CircularProgress size={200} />
    </div>
  );
};
